import type { Sx } from '@/shared/types/uiTypes';

type SxItem = Exclude<Sx, ReadonlyArray<unknown>>;
type SxArrayItem = Extract<NonNullable<Sx>, ReadonlyArray<unknown>>[number];
type NormalizedSxItem = NonNullable<SxItem> | SxArrayItem;

const isSxArray = (sx: Sx | undefined): sx is Extract<NonNullable<Sx>, ReadonlyArray<unknown>> =>
  Array.isArray(sx);

export const normalizeSx = (sx?: Sx): NormalizedSxItem[] => {
  if (isSxArray(sx)) return [...sx];
  if (sx) return [sx];
  return [];
};
